"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const errors_1 = require("./errors");
const assert_1 = require("assert");
describe('errors', () => {
    describe('UrbanjsToolsError', () => {
        it('derives from Error', () => {
            const error = new errors_1.NotFoundTool();
            assert_1.equal(error instanceof Error, true);
        });
    });
    describe('NotFoundTool', () => {
        it('derives from Error', () => {
            const error = new errors_1.NotFoundTool();
            assert_1.equal(error instanceof Error, true);
        });
        it('derives from UrbanjsToolsError', () => {
            const error = new errors_1.NotFoundTool();
            assert_1.equal(error instanceof errors_1.UrbanjsToolsError, true);
        });
    });
});
